import { apiClient } from "../../config";
import { env } from "../../../config/env";

import {
    GetServicesResponse,
    GetServiceResponse,
    UpdateServicePayload,
    CreateServicePayload,
    ServiceImageResponse,
    ServiceCrudResponse,
} from "../../interface/services.interface";

/**
 * ============================================
 * 🧠 SERVICES SERVICE (ADMIN)
 * ============================================
 */

class ServicesService {
    /**
     * 📦 GET ALL SERVICES
     */
    async getServices(): Promise<GetServicesResponse> {
        const { data } = await apiClient.get<GetServicesResponse>(
            env.SERVICES.ADMIN
        );
        return data;
    }

    /**
     * 📄 GET ONE SERVICE
     */
    async getService(id: string): Promise<GetServiceResponse> {
        const { data } = await apiClient.get<GetServiceResponse>(
            `${env.SERVICES.ADMIN}/${id}`
        );
        return data;
    }

    /**
     * ➕ CREATE SERVICE
     */
    async createService(
        payload: CreateServicePayload
    ): Promise<ServiceCrudResponse> {
        const { data } = await apiClient.post<ServiceCrudResponse>(
            env.SERVICES.ADMIN,
            payload
        );
        return data;
    }

    /**
     * ➕ CREATE SERVICE (WITH IMAGE)
     */
    async createServiceWithImage(
        formData: FormData
    ): Promise<ServiceCrudResponse> {
        const { data } = await apiClient.post<ServiceCrudResponse>(
            env.SERVICES.ADMIN,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return data;
    }

    /**
     * ✏️ UPDATE SERVICE
     */
    async updateService(
        id: string,
        payload: UpdateServicePayload
    ): Promise<ServiceCrudResponse> {
        const { data } = await apiClient.put<ServiceCrudResponse>(
            `${env.SERVICES.ADMIN}/${id}`,
            payload
        );
        return data;
    }

    /**
     * 🖼️ UPDATE SERVICE IMAGE
     */
    async updateServiceImage(
        id: string,
        file: File
    ): Promise<ServiceImageResponse> {
        const formData = new FormData();
        formData.append("image", file);

        const { data } = await apiClient.post<ServiceImageResponse>(
            `${env.SERVICES.ADMIN}/${id}/image`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return data;
    }

    /**
     * 🗑️ DELETE SERVICE
     */
    async deleteService(id: string): Promise<ServiceCrudResponse> {
        const { data } = await apiClient.delete<ServiceCrudResponse>(
            `${env.SERVICES.ADMIN}/${id}`
        );
        return data;
    }
}

/**
 * SINGLETON EXPORT
 */
export const servicesService = new ServicesService();